<template>
  <div>
    <QueryForm ref="queryFormRef" @query="onQueryAction">
      <template #parent="{ formData }">
        <ElFormItem label="标签类型">
          <el-select v-model="formData.belongType" style="width: 90px" @change="onQueryAction" filterable clearable placeholder="全部">
            <el-option
              v-for="item in [
                { name: '通用标签', id: 0 },
                { name: '专属标签', id: 1 }
              ]"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem v-if="viewType.table" label="标签层级">
          <el-select v-model="formData.level" @change="onQueryAction" filterable clearable placeholder="全部">
            <el-option v-for="level in 5" :key="level" :label="level" :value="level"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="状态">
          <el-select v-model="formData.aiEnable" @change="onQueryAction" style="width: 80px" filterable clearable placeholder="全部">
            <el-option
              v-for="item in [
                { id: 1, name: '启用' },
                { id: 0, name: '停用' }
              ]"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </ElFormItem>
      </template>

      <div class="search-btn">
        <el-button @click="onShowAddTagModal" type="primary">新增AI标签</el-button>
        <LevelToggleBtn :view-type="viewType" @toggle="toggleViewType"></LevelToggleBtn>
      </div>
    </QueryForm>

    <Viewport ref="viewPortRef" v-model="tableHeight">
      <div v-if="viewType.tree">
        <el-table
          v-loading="tableLoading"
          :data="tagTreeData"
          :height="tableHeight"
          ref="tagTreeTableRef"
          class="common-el-table-styles"
          default-expand-all
          row-key="labelId"
          border
        >
          <el-table-column prop="content" label="标签名称" show-overflow-tooltip>
            <template slot="header">
              <span>标签名称&emsp;</span>
              <el-button type="text" @click="onToggleRowExpansion(true)">展开全部</el-button>
              <el-button type="text" @click="onToggleRowExpansion(false)">收起全部</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="labelId" label="标签ID" width="80"> </el-table-column>
          <el-table-column prop="gameNames" label="游戏" width="190" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="labelDesc" label="标签描述" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="status" label="状态" width="70">
            <template slot-scope="{ row }">
              <el-tag v-if="row.aiEnable" type="success">开启</el-tag>
              <el-tag v-else type="info">关闭</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTimeText" label="创建时间" width="140"> </el-table-column>
          <el-table-column prop="createOpName" label="创建人" width="120"> </el-table-column>
          <el-table-column prop="upTimeText" label="最后修改时间" width="140"> </el-table-column>
          <el-table-column prop="upOpName" label="最后修改人" width="120"> </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="{ row }">
              <el-button type="text" @click="onTableRowUpdate(row)">修改</el-button>
              <el-button type="text" @click="onTableRowRemove(row)">删除</el-button>
              <el-button type="text" @click="onTableRowStateToggle(row)">{{ row.aiEnable ? '停用' : '启用' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <template v-else>
        <el-table
          v-loading="tableLoading"
          class="common-el-table-styles"
          border
          stripe
          :data="tableData"
          :height="tableHeight"
          @selection-change="onTableSelectionChange"
        >
          <el-table-column type="selection" width="39"> </el-table-column>
          <el-table-column prop="labelId" label="标签ID" width="80"> </el-table-column>
          <el-table-column prop="content" label="标签名称" width="140" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="labelPath" label="标签路径" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="level" label="层级" width="50"> </el-table-column>
          <el-table-column prop="relatedMaterialsNum" label="关联素材数" width="80"> </el-table-column>
          <el-table-column prop="gameNames" label="游戏" width="190" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="labelDesc" label="标签描述" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="status" label="状态" width="70">
            <template slot-scope="{ row }">
              <el-tag v-if="row.aiEnable" type="success">开启</el-tag>
              <el-tag v-else type="info">关闭</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="140"> </el-table-column>
          <el-table-column prop="createOpName" label="创建人" width="120"> </el-table-column>
          <el-table-column prop="upTime" label="最后修改时间" width="140"> </el-table-column>
          <el-table-column prop="upOpName" label="最后修改人" width="120"> </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="{ row }">
              <el-button type="text" @click="onTableRowUpdate(row)">修改</el-button>
              <el-button type="text" @click="onTableRowRemove(row)">删除</el-button>
              <el-button type="text" @click="onTableRowStateToggle(row)">{{ row.aiEnable ? '停用' : '启用' }}</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pager">
          <el-pagination
            :current-page.sync="pager.pageId"
            :page-size.sync="pager.pageSize"
            :total="pager.total"
            :page-sizes="[30, 50, 100, 200]"
            @current-change="getTableData"
            @size-change="onQueryAction"
            layout="total, sizes, prev, pager, next, jumper"
            background
          >
          </el-pagination>
        </div>
      </template>
    </Viewport>

    <el-dialog
      :title="modalType === FORM_TYPE.ADD ? '新增AI标签' : '编辑AI标签'"
      :visible.sync="showTagFormModal"
      :close-on-click-modal="false"
      :show-close="false"
      width="540px"
    >
      <AITagForm ref="tagFormRef" :tree-data="parentTags" :form-type="modalType"></AITagForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCloseModal">取 消</el-button>
        <el-button type="primary" :loading="onConfirmLoading" @click="onTagFormConfirm(selectionList)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { getTag } from '@/api/manage.model'
import QueryForm from './components/tags/query-form.vue'
import AITagForm from './components/tags/tag-ai-form.vue'
import LevelToggleBtn from './components/tags/level-toggle-btn.vue'

import { useTable, useAddUpdateModal, useTableView } from './hooks/useTags.js'
import { FORM_TYPE, LABEL_TYPES, LEVEL_TYPES } from './const.js'

const queryFormRef = ref(null)
const viewPortRef = ref(null)
const labelType = LABEL_TYPES.AI_LABEL

const { viewType, onToggleViewType } = useTableView()
const {
  tableData,
  tagTreeData,
  parentTags,
  tagTreeTableRef,
  tableLoading,
  tableHeight,
  pager,
  selectionList,
  onToggleRowExpansion,
  onQueryAction,
  getTreeData,
  getTableData,
  onTableSelectionChange,
  onTableRowRemove,
  onTableRowStateToggle
} = useTable(queryFormRef, labelType, viewType)
const { modalType, showTagFormModal, tagFormRef, onConfirmLoading, onShowAddTagModal, onCloseModal, onTagFormConfirm } = useAddUpdateModal({
  getTableData,
  getTreeData,
  labelType
})

const toggleViewType = () => {
  onToggleViewType()
  nextTick(() => {
    onQueryAction()
    viewPortRef.value.calcHeight()
  })
}

const onTableRowUpdate = (row) => {
  modalType.value = FORM_TYPE.UPDATE
  getTag({ labelId: row.labelId }).then((data) => {
    if (data) {
      const { labelId, content, gameIds, parentId, level, labelDesc, labelPath, aiEnable } = data
      const games = (gameIds?.length ? gameIds.split(',') : []).map(Number)
      showTagFormModal.value = true
      nextTick(() => {
        tagFormRef.value.setForm({
          labelId,
          aiEnable,
          parentId,
          level,
          labelDesc,
          parentIds: labelPath.slice(0, -1),
          label: content,
          gameIds: games,
          gameGroupId: ''
        })
      })
    }
  })
}

onMounted(() => {
  onQueryAction()
  getTreeData()
})
</script>
<style lang="scss" scoped>
.pager {
  text-align: right;
  padding: 5px 0;
}

.search-btn {
  display: flex;
  align-items: center;
}
</style>
